import { DateTimeDisplay } from 'components/date_time/DateTimeDisplay';

export type TimeRangeDisplayProps = Readonly<{
    startDate: Date | null | undefined;
    endDate: Date | null | undefined;
}>;

export function TimeRangeDisplay({ startDate, endDate }: TimeRangeDisplayProps) {
    if (startDate && endDate) {
        return (
            <>
                <DateTimeDisplay date={startDate} />
                <span className="px-5">-</span>
                <DateTimeDisplay date={endDate} />
            </>
        );
    }

    return <></>;
}
